import { render, staticRenderFns } from "./FormAutosuggest.vue?vue&type=template&id=6b01fc3c"
import script from "./FormAutosuggest.vue?vue&type=script&lang=js"
export * from "./FormAutosuggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports